import { KatCheckbox } from '@amzn/katal-react';
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form';


class CheckboxWidget extends React.Component<WidgetProps> {

    handleChange = (evt: any, onChange: Function) => {
        evt.preventDefault();
        onChange(evt.detail.checked);
    };

    render() {

        const { onChange, disabled, label, value } = this.props;

        return (
            <div>
                <KatCheckbox
                    label={label}
                    checked={value}
                    onChange={(evt: any) => this.handleChange(evt, onChange)}
                    disabled={disabled}
                />
            </div>
       );
    }
}

export default CheckboxWidget;
